import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { GeneralService } from 'src/app/api/config/general.service';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
@Component({
  selector: 'app-hotelbookings-extends',
  templateUrl: './hotelbookings-extends.component.html',
  styleUrls: ['./hotelbookings-extends.component.css']
})
export class HotelbookingsExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  submitted: boolean = false;

  // variables
  bookings: any = [];

  constructor(
    public fb: FormBuilder,
    private hotelbookingService: HotelbookingsService,
    private generalService: GeneralService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.item = this.fb.group({
      description: [null, [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  init() {
    this.LoadingModalComponent.show();
    let val_params = '';
    this.hotelbookingService.listCheckins(val_params).subscribe({
      next: (data: any) => {
        this.bookings = data.results;
        console.log('reservas checkins');
        console.log(data);
        this.LoadingModalComponent.hide();
      }
    });
  }

  selectBook(item: any) {
    this.onSubmitEvent.emit(item);
    this.close();
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description_vehicketype')).focus();
    }, 500);
  }

  onSubmit() {
    this.submitted = true;
  }

  close() {
    this.bookings = [];
    (<any>$('#openExtendsHotelbookings')).modal('hide');
  }
}
